'use client';

import useRouteChange from '@/modules/foundation/hooks/useRouteChange';

export default function RouteChangeListener(): null {
	useRouteChange();
	return null;
}
